import React, { useState, useEffect } from 'react';
const API_URL = process.env.REACT_APP_API_URL;
const token = localStorage.getItem('accessToken');

export default function SetoffSection({ caseId, sofaResponse, creditors }) {
  const [setoffs, setSetoffs] = useState([]);
  const [modalOpen, setModalOpen] = useState(false);
  const [editModalOpen, setEditModalOpen] = useState(false);
  const [current, setCurrent] = useState({
    creditor: '',
    description: '',
    setoff_date: '',
    amount: ''
  });

  // Fetch existing setoffs
  useEffect(() => {
    if (!sofaResponse) return;
    (async () => {
      try {
        const res = await fetch(
          `${API_URL}/cases/${caseId}/sofa-setoffs/?sofa_response=${sofaResponse.id}`,
          { headers: { Authorization: `Bearer ${token}` } }
        );
        if (!res.ok) throw new Error('Failed to fetch setoffs');
        setSetoffs(await res.json());
      } catch (e) { console.error(e); }
    })();
  }, [sofaResponse, caseId]);

  // Open Add modal
  function openAddModal() {
    setCurrent({ creditor:'',description:'',setoff_date:'',amount:'' });
    setModalOpen(true);
  }
  // Open Edit modal
  function openEditModal(item) {
    setCurrent({
      id: item.id,
      creditor: item.creditor.id || item.creditor,
      description: item.description,
      setoff_date: item.setoff_date,
      amount: item.amount
    });
    setEditModalOpen(true);
  }

  // Create new setoff
  async function handleSaveNew() {
    try {
      const res = await fetch(
        `${API_URL}/cases/${caseId}/sofa-setoffs/`,
        {
          method: 'POST',
          headers: {'Content-Type':'application/json',Authorization:`Bearer ${token}`},
          body: JSON.stringify(current)
        }
      );
      if (!res.ok) throw new Error('Failed to add setoff');
      const created = await res.json();
      setSetoffs(prev => [...prev, created]);
      setModalOpen(false);
    } catch (e) { console.error(e); }
  }

  // Update existing setoff
  async function handleSaveEdit() {
    try {
      const res = await fetch(
        `${API_URL}/cases/${caseId}/sofa-setoffs/${current.id}/`,
        {
          method: 'PATCH',
          headers: {'Content-Type':'application/json',Authorization:`Bearer ${token}`},
          body: JSON.stringify(current)
        }
      );
      if (!res.ok) throw new Error('Failed to update setoff');
      const updated = await res.json();
      setSetoffs(prev => prev.map(s => s.id===updated.id?updated:s));
      setEditModalOpen(false);
    } catch (e) { console.error(e); }
  }

  // Delete setoff
  async function handleDelete(id) {
    try {
      const res = await fetch(
        `${API_URL}/cases/${caseId}/sofa-setoffs/${id}/`,
        { method:'DELETE',headers:{Authorization:`Bearer ${token}`} }
      );
      if (!res.ok) throw new Error('Failed to delete setoff');
      setSetoffs(prev => prev.filter(s=>s.id!==id));
    } catch (e) { console.error(e); }
  }

  return (
    <section className="p-6 bg-white shadow-lg rounded mb-6">
      <h2 className="text-xl font-semibold mb-4">Question 11: Setoffs</h2>
      <p className="text-sm text-gray-600 mb-4">
            List any setoffs or refusals to make a payment from a creditor because of a debt owed in the last 90 days.
        </p>
      {setoffs.length===0
        ? <p>No setoffs found.</p>
        : <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-4 mb-4">
            {setoffs.map(item=>(
               <div
                    key={item.id}
                    onClick={() => openEditModal(item)}
                    className="p-4 bg-white shadow rounded relative hover:shadow-lg transition-shadow cursor-pointer"
                    >
                <button
                  onClick={e=>{e.stopPropagation();handleDelete(item.id);}}
                  className="absolute top-2 right-2 text-red-600 hover:text-red-800"
                >
                  {/* Trash Icon */}
                  <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5" viewBox="0 0 20 20" fill="currentColor">
                    <path fillRule="evenodd" clipRule="evenodd" d="M6 2a1 1 0 00-1 1v1H3a1 1 0 000 
                      2h14a1 1 0 000-2h-2V3a1 1 0 00-1-1H6zM4 
                      6v10a2 2 0 002 2h8a2 2 0 002-2V6H4zm3 
                      2a1 1 0 000 2v6a1 1 0 102 0V8a1 1 0 00-2 
                      0zm4 0a1 1 0 000 2v6a1 1 0 102 0V8a1 1 0 
                      00-2 0z"/>
                  </svg>
                </button>
                <h3 className="font-medium text-lg">{item.creditor?.account_name || item.creditor}</h3>
                <p className="mt-2 text-sm"><strong>Description:</strong> {item.description}</p>
                <p className="mt-2 text-sm"><strong>Date:</strong> {item.setoff_date}</p>
                <p className="mt-2 text-sm"><strong>Amount:</strong> ${item.amount}</p>
              </div>
            ))}
          </div>
      }
      <button
        onClick={openAddModal}
        className="px-4 py-2 bg-indigo-600 text-white rounded hover:bg-indigo-700"
      >
        Add Setoff
      </button>

      {/* Add Modal */}
      {modalOpen && (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
          <div className="bg-white p-4 sm:p-6 rounded shadow-lg w-full max-w-md">
            <h3 className="text-lg font-semibold mb-4">Add Setoff</h3>
            <div className="mb-3">
              <label className="block text-sm font-medium mb-1">Creditor</label>
              <select
                className="w-full border rounded px-2 py-1"
                value={current.creditor}
                onChange={e=>setCurrent(prev=>({...prev,creditor:e.target.value}))}
              >
                <option value="">Select creditor</option>
                {creditors.map(c=>(
                  <option key={c.id} value={c.id}>{c.name}</option>
                ))}
              </select>
            </div>
            <div className="mb-3">
              <label className="block text-sm font-medium mb-1">Description</label>
              <textarea
                className="w-full border rounded px-2 py-1"
                value={current.description}
                onChange={e=>setCurrent(prev=>({...prev,description:e.target.value}))}
              />
            </div>
            <div className="grid grid-cols-2 gap-4 mb-3">
              <div>
                <label className="block text-sm font-medium mb-1">Date</label>
                <input
                  type="date"
                  className="w-full border rounded px-2 py-1"
                  value={current.setoff_date}
                  onChange={e=>setCurrent(prev=>({...prev,setoff_date:e.target.value}))}
                />
              </div>
              <div>
                <label className="block text-sm font-medium mb-1">Amount</label>
                <input
                  type="number"
                  step="0.01"
                  className="w-full border rounded px-2 py-1"
                  value={current.amount}
                  onChange={e=>setCurrent(prev=>({...prev,amount:e.target.value}))}
                />
              </div>
            </div>
            <div className="flex justify-end space-x-2 mt-4">
              <button onClick={()=>setModalOpen(false)} className="px-4 py-2 bg-gray-200 rounded">Cancel</button>
              <button onClick={handleSaveNew} className="px-4 py-2 bg-blue-600 text-white rounded">Save</button>
            </div>
          </div>
        </div>
      )}
      {/* Edit Modal */}
      {editModalOpen && (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
          <div className="bg-white p-4 sm:p-6 rounded shadow-lg w-full max-w-md">
            <h3 className="text-lg font-semibold mb-4">Edit Setoff</h3>
            <div className="mb-3">
              <label className="block text-sm font-medium mb-1">Creditor</label>
              <select
                className="w-full border rounded px-2 py-1"
                value={current.creditor}
                onChange={e=>setCurrent(prev=>({...prev,creditor:e.target.value}))}
              >
                <option value="">Select creditor</option>
                {creditors.map(c=>(
                  <option key={c.id} value={c.id}>{c.name}</option>
                ))}
              </select>
            </div>
            <div className="mb-3">
              <label className="block text-sm font-medium mb-1">Description</label>
              <textarea
                className="w-full border rounded px-2 py-1"
                value={current.description}
                onChange={e=>setCurrent(prev=>({...prev,description:e.target.value}))}
              />
            </div>
            <div className="grid grid-cols-2 gap-4 mb-3">
              <div>
                <label className="block text-sm font-medium mb-1">Date</label>
                <input
                  type="date"
                  className="w-full border rounded px-2 py-1"
                  value={current.setoff_date}
                  onChange={e=>setCurrent(prev=>({...prev,setoff_date:e.target.value}))}
                />
              </div>
              <div>
                <label className="block text-sm font-medium mb-1">Amount</label>
                <input
                  type="number"
                  step="0.01"
                  className="w-full border rounded px-2 py-1"
                  value={current.amount}
                  onChange={e=>setCurrent(prev=>({...prev,amount:e.target.value}))}
                />
              </div>
            </div>
            <div className="flex justify-end space-x-2 mt-4">
              <button onClick={()=>setEditModalOpen(false)} className="px-4 py-2 bg-gray-200 rounded">Cancel</button>
              <button onClick={handleSaveEdit} className="px-4 py-2 bg-blue-600 text-white rounded">Save</button>
            </div>
          </div>
        </div>
      )}
    </section>
);
}